import { Deserializable } from './deserializable.model';
import { Domain } from './domain.model';

export class PredefinedSearch extends Domain implements Deserializable<any, PredefinedSearch> {
  constructor(id?: string, key?: string, name?: string, term?: string, public tracked = false) {
    super(id, key, name, term);
  }

  deserialize(input: any): PredefinedSearch {
    if (input == null) {
      return null;
    }

    this.id = input['id'];
    this.key = input['key'];
    this.name = input['name'];
    this.term = input['term'];
    this.tracked = input['tracked'];

    return this;
  }
}
